import { gql } from '@apollo/client';
import { forPaginated } from './common/paginated.graphql';
import { KitTemplate } from '../types/kit_template/kitTemplate';
import {
  CreateKitTemplateInput,
  DeleteKitTemplateInput,
  UpdateKitTemplateInput,
} from '../types/kit_template/kitTemplate.input';

const kitTemplate = gql`
  fragment KitTemplate on KitTemplate {
    id
    version
    companyId
    createdAt
    createdBy
    updatedAt
    updatedBy
    name
    productMasterDataId
    products {
      productMasterDataId
      quantity
    }
  }
`;

const get = gql`
  query KitTemplates($page: Float) {
    kitTemplates(page: $page) {
      data {
        ...KitTemplate
      }
      page
      pageSize
      batchSize
      hasNext
    }
  }
  ${kitTemplate}
`;

export interface GetKitTemplatesVariables {
  page?: number;
}

export interface GetKitTemplatesResponse {
  kitTemplates: PaginatedKitTemplates;
}

class PaginatedKitTemplates extends forPaginated<KitTemplate>() {}

const create = gql`
  mutation CreateKitTemplate($templates: [CreateKitTemplateInput!]!) {
    createKitTemplate(templates: $templates) {
      ...KitTemplate
    }
  }
  ${kitTemplate}
`;

export interface CreateKitTemplateVariables {
  templates: CreateKitTemplateInput[];
}

export interface CreateKitTemplateResponse {
  createKitTemplate: KitTemplate[];
}

const update = gql`
  mutation UpdateKitTemplate($templates: [UpdateKitTemplateInput!]!) {
    updateKitTemplate(templates: $templates) {
      ...KitTemplate
    }
  }
  ${kitTemplate}
`;

export interface UpdateKitTemplateVariables {
  templates: UpdateKitTemplateInput[];
}

export interface UpdateKitTemplateResponse {
  updateKitTemplate: KitTemplate[];
}

const remove = gql`
  mutation DeleteKitTemplate($templates: [DeleteKitTemplateInput!]!) {
    deleteKitTemplate(templates: $templates) {
      ...KitTemplate
    }
  }
  ${kitTemplate}
`;

export interface DeleteKitTemplateVariables {
  templates: DeleteKitTemplateInput[];
}

export interface DeleteKitTemplateResponse {
  deleteKitTemplate: KitTemplate[];
}

export const KitTemplateQueries = {
  get,
};

export const KitTemplateMutations = {
  create,
  update,
  remove,
};

export const KitTemplateFragment = {
  kitTemplate: kitTemplate,
};
